import { systemCode, xs_languageCode } from '..';
import { getConfiguration, getTimezoneOffset } from './utils';
import $ from 'jquery';

export const PURCHASE_RETRY = 1;
export const PAYMENT_TICKET_RETRY = 2;
export const CANCEL_TICKET_RETRY = 3;
export const GENERATE_REST_VOUCHER_RETRY = 4;
export const ACCOUNT_RECHARGE_PHYSICAL_SELF_RETRY = 5;

export function generateFrontendTransactionId(user){
	if(!user){
		return null;
	}
	let tranId = '';
	if(user.operator || user.selfCashier){
		tranId = [systemCode ,user.cn, user.pvend, user.idTag, Date.now()].join("-");
	}
	else{
		tranId = [systemCode ,user.accountNum, Date.now()].join("-");
	}
	
	return tranId;
}

export function saveFrontendTransactionId(frontendTransactionId, type){
	const data = {
		frontendTransactionId,
		type
	};
	localStorage.setItem('XS_RETRY_TRANSACTION_ID', JSON.stringify(data));
}

export function removeFrontendTransactionId(){
	localStorage.removeItem('XS_RETRY_TRANSACTION_ID');
}

export function getPendingFrontendTransactionId(){
	const stringed = localStorage.getItem('XS_RETRY_TRANSACTION_ID');
	if(stringed){
		return JSON.parse(stringed);
	}
	return null;
}

function startRetryCheckStatusTransaction(frontendTransactionId, serviceUrl, params, successCallback, errorCallback, retryNumber){
	console.debug("Retry number: " + retryNumber + " for transaction " + frontendTransactionId);
	const conf = getConfiguration();
	const ajaxTimeout = conf.pffts != null? (conf.pffts) * 1000 : 10000;
	const timeoutPollingCheckStatusTransaction = conf.ptcst? conf.ptcst : 500;
	$.ajax({
		type: "POST",
		url : serviceUrl + "?" +  $.param(params),
		data: null,
        dataType: 'json',
        contentType: "application/json; charset=UTF-8;",
        timeout: ajaxTimeout,
        headers:{
        	'Cache-Control': 'no-transform'
        },
		success : (data) => {
			if(data){
				console.debug("Retry response code is "+data?.code)

				if(data.code === 0){
					// success!!
					if(data.object.code === 0){
						removeFrontendTransactionId();
						console.debug("Transaction " + frontendTransactionId + " has been succesfully finalized. Calling successCallback...");
						try {
							console.debug("Transaction " + frontendTransactionId + " response: ["+JSON.stringify(data)+"]");
						}catch(err) {
							console.error(err);
						}
						successCallback(data.object);
					}
					else{
						removeFrontendTransactionId();
						errorCallback(data.object.description);
					}

				}
				else if(data.code === -104 || data.code === 3002){
					setTimeout(() => {
						startRetryCheckStatusTransaction(frontendTransactionId, serviceUrl, params, successCallback, errorCallback, retryNumber + 1);
					}, timeoutPollingCheckStatusTransaction);
				}
				else{
					removeFrontendTransactionId();
					errorCallback();
				}
			}
			else{
				console.debug("Retry response data is NULL");
				setTimeout(() => {
					startRetryCheckStatusTransaction(frontendTransactionId, serviceUrl, params, successCallback, errorCallback, retryNumber + 1);
				}, timeoutPollingCheckStatusTransaction);
			}
		},
		error : (jqXHR, textStatus, errorThrown) => {
			console.error("ERROR in function startRetryCheckStatusTransaction ON [" + frontendTransactionId + "] " + jqXHR?.status + " " + jqXHR?.statusText + " " + textStatus + " " + errorThrown);
			try {
				console.error(JSON.stringify(jqXHR));
			}catch(e) {
			}
			setTimeout(() => {
				startRetryCheckStatusTransaction(frontendTransactionId, serviceUrl, params, successCallback, errorCallback, retryNumber + 1);
			}, timeoutPollingCheckStatusTransaction);
		}	
 });
}

export function retryCheckPurchaseTicket(frontendTransactionId, shopUserData, sessionToken, successCallback, errorCallback){
	 console.debug('Starting ticket retry flow  for ' + frontendTransactionId);
	 const shopUserType = shopUserData != null? (shopUserData.operator? 'operator' : 'self-cashier') : null;
	try{
		 const url = getConfiguration().api['checkPurchaseTransactionStatus'];
		 const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            token : sessionToken,
           	shopUserType,
            frontendTransactionId,
            offsetHours : getTimezoneOffset()
	     };
		 startRetryCheckStatusTransaction(frontendTransactionId, url, params, successCallback, errorCallback, 1);	 
	}
	catch(exception){
		console.error('Ticket data not found due to ' + exception);
		removeFrontendTransactionId();
		console.error('Transaction ' + frontendTransactionId + ' has been removed from local storage')
		errorCallback();
	}
}

export function retryCheckGenerateRestVoucher(frontendTransactionId, successCallback, errorCallback){
	console.debug('Starting ticket retry flow  for ' + frontendTransactionId);
	try{
		 const url = getConfiguration().api['shop.checkGenerateRestVoucherTransaction'];
		 const params = {
	            systemCode,
	            lingua: xs_languageCode,
	            hash: '',
	            frontendTransactionId
	     };
		 startRetryCheckStatusTransaction(frontendTransactionId, url, params, successCallback, errorCallback, 1);	 
	}
	catch(exception){
		console.error('Ticket data not found due to ' + exception);
		removeFrontendTransactionId();
		console.error('Transaction ' + frontendTransactionId + ' has been removed from local storage')
		errorCallback();
	}
}